<template>
  <section>
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <!--列表-->
    <el-table
      :data="costtypes"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%;"
    >
      <el-table-column
        type="selection"
        width="50"
      >
      </el-table-column>
      <el-table-column
        type="index"
        width="80"
      >
      </el-table-column>
      <el-table-column
        prop="TypeName"
        label="费用类型名称"
        width=""
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="TypeNo"
        label="费用类型代码"
        width=""
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="SubjectNo"
        label="对应科目"
        width="300"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="HSWD"
        label="核算维度"
        width="300"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="Reamrk"
        label="摘要模板"
        width="300"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        width=""
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="CreateBy"
        label="创建者"
        width=""
        sortable
      >
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col
      :span="24"
      class="toolbar"
    >
      <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length===0"
      >批量删除</el-button>
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="aeditFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item
          label="类型名称"
          prop="TypeName"
        >
          <el-input
            v-model="editForm.TypeName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="类型代码"
          prop="TypeNo"
        >
          <el-input
            v-model="editForm.TypeNo"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="对应科目"
          prop="SubjectNo"
        >
          <el-input
            v-model="editForm.SubjectNo"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="核算维度"
          prop="HSWD"
        >
          <el-input
            v-model="editForm.HSWD"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="摘要模板"
          prop="Reamrk"
        >
          <el-input
            v-model="editForm.Reamrk"
            auto-complete="off"
          ></el-input>
        </el-form-item>

      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item
          label="类型名称"
          prop="TypeName"
        >
          <el-input
            v-model="addForm.TypeName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="对应部门"
          prop="DepID"
        >
          <el-select
            v-model="addForm.DepID"
            placeholder="请选择部门"
          >
            <el-option
              :key="0"
              :label="'未选择部门'"
              :value="0"
            ></el-option>
            <el-option
              v-for="item in deps"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="借方科目"
          prop="SubjectNoJ"
        >
          <el-input
            v-model="addForm.SubjectNoJ"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="贷方科目"
          prop="SubjectNoD"
        >
          <el-input
            v-model="addForm.SubjectNoD"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="调整科目"
          prop="SubjectNoTZ"
        >
          <el-input
            v-model="addForm.SubjectNoTZ"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="核算维度"
          prop="HSWD"
        >
          <el-input
            v-model="addForm.HSWD"
            auto-complete="off"
            :disabled="true"
            placeholder="保存后会自动取值"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="摘要模板"
          prop="Reamrk"
        >
          <el-input
            v-model="addForm.Reamrk"
            auto-complete="off"
          ></el-input>
        </el-form-item> -->

      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
        >提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import { getCostTypeListPage, removeCostType, editCostType, addCostType, getDepListPage } from '../../api/api';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: ''
      },
      costtypes: [],
      total: 0,
      page: 1,
      deps: [],
      listLoading: false,
      sels: [],//列表选中列

      addDialogFormVisible: false,
      editFormVisible: false,//编辑界面是否显示
      editLoading: false,
      editFormRules: {
        // Name: [
        //   { required: true, message: '请输入部门名称', trigger: 'blur' }
        // ],
        // Number: [
        //   { required: true, message: '请输入部门编码', trigger: 'blur' }
        // ]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: '',
        Number: '',
        Name: '',
        Enabled: false,
      },

      addFormVisible: false,//新增界面是否显示
      addLoading: false,
      addFormRules: {

        // Name: [
        //   { required: true, message: '请输入部门名称', trigger: 'blur' }
        // ],
        // Number: [
        //   { required: true, message: '请输入部门编码', trigger: 'blur' }
        // ]

      },
      //新增界面数据
      addForm: {
        CreateBy: '',
        CreateId: '',
        Number: '',
        Name: '',
        Enabled: '',
      }

    }
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    formatCreateTime: function(row, column) {
      return (!row.CreateTime || row.CreateTime == '') ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd');
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleget();
    },
    //获取用户列表
    handleget() {

      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      //NProgress.start();
      getCostTypeListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.costtypes = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //获取部门列表
    getDeps() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      getDepListPage(para).then((res) => {
        this.deps = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {


        this.listLoading = true;
        //NProgress.start();
        let para = { id: row.Id };
        removeCostType(para).then((res) => {

          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          //NProgress.done();
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });

          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }

          this.handleget();
        });
      }).catch(() => {

      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: '',
        Number: '',
        Name: '',
        Enabled: 'true',
      };
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.ModifyTime = util.formatDate.format(new Date(), 'yyyy-MM-dd');

            editCostType(para).then((res) => {

              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs['editForm'].resetFields();
                this.editFormVisible = false;
                this.handleget();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });

              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            para.CreateTime = util.formatDate.format(new Date(), 'yyyy-MM-dd');
            para.ModifyTime = para.CreateTime;
            para.IsDeleted = false;

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: '用户信息为空，先登录',
                type: 'error'
              });
              _this.$router.replace(_this.$route.query.redirect ? _this.$route.query.redirect : "/");
            }


            addCostType(para).then((res) => {

              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.handleget();
              }
              else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
                this.addLoading = false;

              }

            });

          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: '该功能未开放',
        type: 'warning'
      });
    }
  },
  mounted() {
    this.handleget();
    this.getDeps();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
}

</script>

<style scoped>
</style>
